import React, { useRef } from "react";
import SubMenuItem from "../subMenuItem/SubMenuItem";
import "./menuItem.scss";
import { useState, useEffect } from "react";

const MenuItem = ({ name, subMenuItems, permissionsArr }) => {
    const menuItemRef = useRef();

    const [showMenuItem, setShowMenuItem] = useState(false);

    useEffect(() => {
        const outsideHandleClick = (e) => {
            if (menuItemRef.current && !e.composedPath().includes(menuItemRef.current)) {
                setShowMenuItem(false);
            }
        };

        document.body.addEventListener("click", outsideHandleClick);

        return () => {
            document.body.removeEventListener("click", outsideHandleClick);
        };
    }, []);

    return (
        <div
            className={showMenuItem ? "menu__item menu__item-active" : "menu__item"}
            ref={menuItemRef}
            onClick={() => setShowMenuItem(!showMenuItem)}
        >
            {name}
            <span className="caret"></span>
            <SubMenuItem menuItems={subMenuItems} showMenuItem={showMenuItem} permissionsArr={permissionsArr} />
        </div>
    );
};

export default MenuItem;
